import './InformationalHeroCards.css';
import React from 'react';
import { get, getPageThemeColors, getColorByTheme, canUseDOM } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
export const InformationalHeroCards = _ref => {
  let {
    fields,
    params,
    bannerSlideTitle = ''
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const links = get(fields, 'data.item.cards.targetItems') || [];
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--m113-InformationalHeroCards-background-color': BackgroundColorHex,
    '--m113-InformationalHeroCards-background-active-color': ActiveColorHex,
    '--m113-InformationalHeroCards-color': ColorHex
  } : {
    '--m113-InformationalHeroCards-background-color': selectedPrimaryColor,
    '--m113-InformationalHeroCards-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-InformationalHeroCards-color': getColorByTheme(selectedPrimaryColor)
  };
  if (!get(fields, 'data.item')) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('InformationalHeroCards component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [InformationalHeroCards component is empty: please provide data source]");
    }
    return null;
  }
  const renderLinks = () => {
    if (links && links.length) {
      return links.map((el, index) => {
        const id = get(el, 'id');
        const title = get(el, 'title.jss.value');
        const desc = get(el, 'shortDescription.jss.value');
        const icon = get(el, 'svgIcon.targetItem.svg.jss.value');
        const linkHref = get(el, 'link.jss.value.href');
        return /*#__PURE__*/React.createElement(RouterLink, {
          className: `m113-card`,
          href: linkHref,
          key: id,
          onClick: () => {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['cardsClickAnalytics'], params), [title, bannerSlideTitle]);
          },
          dataCy: "multifunctional-card-link",
          linktype: "external",
          openInSameTab: true
        }, icon ? /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: icon
          },
          className: "icon"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
          className: "m113-card__title"
        }, title), /*#__PURE__*/React.createElement("p", {
          className: "m113-card__text"
        }, desc));
      });
    }
    return /*#__PURE__*/React.createElement("div", null);
  };
  const renderCarousel = () => {
    return /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
      let {
        renderCarousel,
        renderPreviousButton,
        renderNextButton,
        renderDots,
        state
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: ``
      }, renderCarousel(renderLinks(), {
        responsive: {
          desktopLarge: {
            breakpoint: {
              max: 10000,
              min: 1700
            },
            items: 5,
            partialVisibilityGutter: 0
          },
          desktop: {
            breakpoint: {
              max: 1699,
              min: 1200
            },
            items: 4,
            partialVisibilityGutter: 0
          },
          tabletLarge: {
            breakpoint: {
              max: 1199,
              min: 768
            },
            items: 3,
            partialVisibilityGutter: 20
          },
          tablet: {
            breakpoint: {
              max: 767,
              min: 480
            },
            items: 2,
            partialVisibilityGutter: 20
          },
          mobile: {
            breakpoint: {
              max: 479,
              min: 0
            },
            items: 1,
            partialVisibilityGutter: 150
          }
        },
        containerClass: '',
        partialVisible: true
      })));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "m113-mult-card",
    style: variables
  }, renderCarousel()));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cvupt7m";
const ltrStyles = "l4kkmk9";
const rtlStyles = "r1m1i4y2";
export default InformationalHeroCards;